<div class="main">
  <span class="loading-number" *ngIf="loadingService.fileLoading">
    {{loadingService.loadingProgress}}%
  </span>
  <div class="s1">
    <div class="s b sb1"></div>
    <div class="s b sb2"></div>
    <div class="s b sb3"></div>
    <div class="s b sb4"></div>
  </div>
  <div class="s2">
    <div class="s b sb5"></div>
    <div class="s b sb6"></div>
    <div class="s b sb7"></div>
    <div class="s b sb8 test"></div>
  </div>
  <div class="bigcon">
    <div class="big b"></div>
  </div>
  <div class="container-message">
    <span class="loading-hierarchy" *ngIf="(loadingService.hierarchyLoading | async)">
      <strong>
        {{loadingService.hierarchyLoadingText}}
        <br>
        This process may take a moment.
      </strong>
    </span>
  </div>
</div>